import { useState, useEffect } from 'react';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [consultationStats, setConsultationStats] = useState([
    { name: '김○○', location: '김해시', time: '3일 전', type: '개인회생 상담' },
    { name: '이○○', location: '부산시', time: '하루 전', type: '채무조정 상담' },
    { name: '박○○', location: '창원시', time: '5일 전', type: '파산 상담' },
    { name: '최○○', location: '양산시', time: '2일 전', type: '개인회생 상담' },
    { name: '정○○', location: '진주시', time: '일주일 전', type: '면책 상담' },
    { name: '강○○', location: '거제시', time: '4일 전', type: '채무조정 상담' },
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      const names = ['김○○', '이○○', '박○○', '최○○', '정○○', '강○○', '윤○○', '장○○', '임○○', '한○○'];
      const locations = ['김해시', '부산시', '창원시', '양산시', '진주시', '거제시', '통영시', '사천시', '밀양시', '함안군'];
      const types = ['개인회생 상담', '채무조정 상담', '파산 상담', '면책 상담', '변제계획 상담'];
      
      // 랜덤 시간 생성 (하루 ~ 일주일 전)
      const getRandomTime = () => {
        const pick = Math.floor(Math.random() * 7) + 1;
        if (pick === 1) return '하루 전';
        if (pick === 7) return '일주일 전';
        return `${pick}일 전`;
      };
      
      const newConsultation = {
        name: names[Math.floor(Math.random() * names.length)],
        location: locations[Math.floor(Math.random() * locations.length)],
        time: '하루 전',
        type: types[Math.floor(Math.random() * types.length)]
      };

      setConsultationStats(prev => {
        const updated = prev.map(item => ({ ...item, time: getRandomTime() }));
        return [newConsultation, ...updated.slice(0, 5)];
      });
    }, 15000);

    const schemaLegal = {
      "@context": "https://schema.org",
      "@type": "LegalService",
      "name": "우리법무사 조동식, 조동섭 사무소",
      "description": "김해 개인회생·파산신청·채무조정·소송사건 전문 법무사 사무소. 33년 경력 조동식 법무사와 법원 1급공무원 출신 조동섭 법무사가 800건 이상 성공 사례를 보유합니다.",
      "url": import.meta.env.VITE_SITE_URL ?? "https://example.com",
      "telephone": "0507-1472-9902",
      "priceRange": "무료 상담",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "금관대로 1364번길17, 2층",
        "addressLocality": "김해시",
        "addressRegion": "경상남도",
        "postalCode": "50981",
        "addressCountry": "KR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.2281,
        "longitude": 128.889
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Saturday"],
          "opens": "09:00",
          "closes": "13:00"
        }
      ],
      "areaServed": ["김해시", "부산시", "창원시", "경상남도"],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "법무 서비스",
        "itemListElement": [
          {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "개인회생 신청"}},
          {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "파산신청"}},
          {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "채무조정"}},
          {"@type": "Offer", "itemOffered": {"@type": "Service", "name": "소송사건"}}
        ]
      }
    };

    const schemaFAQ = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "개인회생 신청 자격은 어떻게 되나요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "개인회생은 급여소득자나 영업소득자로서 지급불능 상태에 있거나 지급불능 우려가 있는 개인채무자가 신청할 수 있습니다. 채무 총액이 무담보채무 10억 원, 담보채무 15억 원 이하여야 합니다."
          }
        },
        {
          "@type": "Question",
          "name": "개인회생 절차는 얼마나 걸리나요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "개인회생 절차는 신청 후 인가결정까지 약 3~6개월 소요되며, 변제기간은 보통 3~5년입니다. 우리법무사 사무소는 신속하고 정확한 서류 준비로 절차를 단축해 드립니다."
          }
        },
        {
          "@type": "Question",
          "name": "파산신청과 개인회생의 차이는 무엇인가요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "개인회생은 일정 소득이 있는 분이 변제계획을 세워 채무를 일부 갚으면서 나머지를 면책받는 제도이고, 파산신청은 소득이 없거나 매우 적어 변제 능력이 없는 분이 모든 채무를 면책받는 제도입니다."
          }
        },
        {
          "@type": "Question",
          "name": "무료 상담이 가능한가요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "네, 우리법무사 조동식, 조동섭 사무소는 개인회생·파산신청·소송사건에 대한 무료 상담을 제공합니다. 온라인 신청 또는 전화(0507-1472-9902)로 언제든지 연락 주세요."
          }
        }
      ]
    };

    const insertSchema = (id: string, data: object) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    };

    insertSchema('schema-legal', schemaLegal);
    insertSchema('schema-faq', schemaFAQ);

    return () => {
      document.getElementById('schema-legal')?.remove();
      document.getElementById('schema-faq')?.remove();
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "Pacifico, serif" }}>
                우리법무사 조동식 조동섭 사무소
              </h1>
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <a href="#home" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">홈</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">무료 상담</a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">사무소 소개</a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">업무 분야</a>
            </nav>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-blue-600 cursor-pointer"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-100">
              <div className="flex flex-col space-y-3">
                <a href="#home" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">홈</a>
                <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">무료 상담</a>
                <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">사무소 소개</a>
                <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">업무 분야</a>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative bg-gradient-to-br from-slate-50 to-blue-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-loose">
                  빚에서 빛으로,<br />
                  <span className="text-blue-600">명쾌한 해결책</span>을<br />
                  제시합니다
                </h2>
                <p className="text-xl text-gray-600 leading-relaxed">
                  33년 경력의 조동식 법무사와 법원 1급공무원 출신 조동섭 법무사가<br />
                  개인회생 전문 서비스로 새로운 시작을 도와드립니다
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="#contact"
                  className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  무료 상담 신청
                </a>
                <a 
                  href="https://map.naver.com/p/entry/place/36620186?placePath=/home?entry=plt&from=map&fromPanelNum=1&additionalHeight=76&timestamp=202510311632&locale=ko&svcName=map_pcv5&searchType=place&lng=128.8685740&lat=35.2442610&c=15.00,0,0,0,dh"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-100 text-blue-700 px-8 py-4 rounded-lg font-semibold hover:bg-blue-200 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  사무소 둘러보기
                </a>
              </div>

              <div className="grid grid-cols-3 gap-6 pt-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">800+</div>
                  <div className="text-sm text-gray-600 mt-1">성공 사례</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">33년</div>
                  <div className="text-sm text-gray-600 mt-1">경력</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">100%</div>
                  <div className="text-sm text-gray-600 mt-1">신뢰도</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/0d07ace66fb4512267f18a4893030c41.jpg"
                alt="우리법무사 조동식, 조동섭 사무소"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section - Moved to top */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">무료 상담 신청</h3>
            <p className="text-xl text-gray-600">전문가와의 상담으로 최적의 해결책을 찾아보세요</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16">
            <div className="space-y-8">
              <div className="bg-gray-50 p-8 rounded-xl">
                <h4 className="text-xl font-bold text-gray-900 mb-6">개인회생  파산 무료 상담</h4>
                <form 
                  className="space-y-6" 
                  data-readdy-form
                  action="https://readdy.ai/api/form/d42631jupn899ion1f9g"
                  method="POST"
                  onSubmit={(e) => {
                    e.preventDefault();
                    const formData = new FormData(e.target as HTMLFormElement);
                    const data = new URLSearchParams();
                    formData.forEach((value, key) => {
                      data.append(key, value.toString());
                    });
                    
                    fetch('https://readdy.ai/api/form/d42631jupn899ion1f9g', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                      body: data
                    }).then(() => {
                      alert('상담 신청이 완료되었습니다. 빠른 시일 내에 연락드리겠습니다.');
                      (e.target as HTMLFormElement).reset();
                    }).catch(() => {
                      alert('신청 중 오류가 발생했습니다. 다시 시도해주세요.');
                    });
                  }}
                >
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">이름 *</label>
                    <input 
                      type="text" 
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="성함을 입력해주세요"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">연락처 *</label>
                    <input 
                      type="tel" 
                      name="phone"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="연락 가능한 번호를 입력해주세요"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">상담 분야 (복수 선택 가능)</label>
                    <div className="grid grid-cols-2 gap-3">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input 
                          type="checkbox" 
                          name="consultation_type" 
                          value="개인회생"
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-700">개인회생</span>
                      </label>
                      
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input 
                          type="checkbox" 
                          name="consultation_type" 
                          value="파산신청"
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-700">파산신청</span>
                      </label>

                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input 
                          type="checkbox" 
                          name="consultation_type" 
                          value="소송사건"
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-700">소송사건</span>
                      </label>

                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input 
                          type="checkbox" 
                          name="consultation_type" 
                          value="기타사건"
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-700">기타사건</span>
                      </label>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">상담 내용</label>
                    <textarea 
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                      placeholder="상담받고 싶은 내용을 간단히 적어주세요 (최대 500자)"
                    ></textarea>
                  </div>

                  <button 
                    type="submit"
                    className="w-full bg-blue-600 text-white py-4 rounded-lg font-semibold hover:bg-blue-7

                    transition-colors whitespace-nowrap cursor-pointer"
                  >
                    무료 상담 신청하기
                  </button>
                </form>
              </div>

              <div className="bg-blue-50 p-8 rounded-xl">
                <h4 className="text-xl font-bold text-gray-900 mb-4">상담 절차</h4>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">1</div>
                    <p className="text-gray-700">전화 또는 온라인 상담 신청</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">2</div>
                    <p className="text-gray-700">개인 상황 분석 및 진단</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">3</div>
                    <p className="text-gray-700">최적 해결방안 제시</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">4</div>
                    <p className="text-gray-700">법률 서비스 진행</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl">
                <h4 className="text-xl font-bold text-gray-900 mb-4">전화 상담</h4>
                <p className="text-gray-600 mb-6">
                  전화상담이 필요하시면 바로 문의주세요.<br />
                  전문사무장이 친절하게 안내도와드립니다.
                </p>
                <div className="flex justify-center">
                  <a 
                    href="tel:0507-1472-9902"
                    className="flex items-center justify-center bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    전화 상담 (0507-1472-9902)
                  </a>
                </div>
              </div>

            </div>

            <div className="space-y-8">
              <div className="bg-white border border-gray-200 p-8 rounded-xl">
                <h4 className="text-xl font-bold text-gray-900 mb-6">사무소 위치</h4>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <i className="ri-map-pin-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <p className="font-semibold text-gray-900">주소</p>
                      <p className="text-gray-600">김해시 금관대로 1364번길17, 2층</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <i className="ri-phone-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <p className="font-semibold text-gray-900">전화번호</p>
                      <p className="text-gray-600">0507-1472-9902</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <i className="ri-time-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <p className="font-semibold text-gray-900">운영시간</p>
                      <p className="text-gray-600">평일 09:00 - 18:00</p>
                      <p className="text-gray-600">토요일 09:00 - 13:00</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl">
                <h4 className="text-xl font-bold text-gray-900 mb-4">전화 상담</h4>
                <p className="text-gray-600 mb-6">
                  전화상담이 필요하시면 바로 문의주세요.<br />
                  전문사무장이 친절하게 안내도와드립니다.
                </p>
                <div className="flex justify-center">
                  <a 
                    href="tel:0507-1472-9902"
                    className="flex items-center justify-center bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    전화 상담 (0507-1472-9902)
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">전문 업무 분야</h3>
            <p className="text-xl text-gray-600">개인회생 전문가로서 최적의 해결책을 제시합니다</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-blue-50 p-8 rounded-xl text-center hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">개인회생 파산신청</h4>
              <p className="text-gray-600">복잡한 개인회생 절차를 체계적으로 진행합니다</p>
            </div>

            <div className="bg-green-50 p-8 rounded-xl text-center hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-scales-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">채무조정</h4>
              <p className="text-gray-600">개인 상황에 맞는 최적의 채무조정 방안 제시</p>
            </div>

            <div className="bg-purple-50 p-8 rounded-xl text-center hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-16 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">변제계획 수립</h4>
              <p className="text-gray-600">실현 가능한 변제계획으로 새로운 시작을 지원</p>
            </div>

            <div className="bg-orange-50 p-8 rounded-xl text-center hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">면책 절차</h4>
              <p className="text-gray-600">완전한 경제적 회복을 위한 면책 절차 진행</p>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Reviews */}
      <section className="py-20 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">고객 후기</h3>
            <p className="text-xl text-gray-600">실제 고객들의 생생한 경험담을 들어보세요</p>
          </div>

          <div className="relative">
            <div className="flex animate-scroll space-x-8">
              {/* First set of reviews */}
              <div className="flex-shrink-0 w-80 bg-gray-50 p-6 rounded-xl shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <span className="ml-2 text-sm text-gray-600">5.0</span>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "개인회생 절차가 복잡해서 걱정했는데, 조동식 법무사님께서 처음부터 끝까지 친절하게 설명해주시고 도와주셔서 무사히 마칠 수 있었습니다. 정말 감사합니다."
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 font-semibold">김</span>
                  </div>
                  <div className="ml-3">
                    <p className="font-semibold text-gray-900">김○○님</p>
                    <p className="text-sm text-gray-600">개인회생 성공</p>
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0 w-80 bg-gray-50 p-6 rounded-xl shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <span className="ml-2 text-sm text-gray-600">5.0</span>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "법원 출신이신 조동섭 법무사님의 전문성이 정말 뛰어나셨습니다. 빠르고 정확한 업무 처리로 예상보다 훨씬 빨리 해결되었습니다."
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <span className="text-green-600 font-semibold">이</span>
                  </div>
                  <div className="ml-3">
                    <p className="font-semibold text-gray-900">이○○님</p>
                    <p className="text-sm text-gray-600">채당조정 완료</p>
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0 w-80 bg-gray-50 p-6 rounded-xl shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <span className="ml-2 text-sm text-gray-600">5.0</span>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "33년 경력이 정말 느껴졌습니다. 어려운 상황에서도 희망을 잃지 않게 해주시고, 실제로 좋은 결과를 얻을 수 있었습니다. 진심으로 감사드립니다."
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-semibold">박</span>
                  </div>
                  <div className="ml-3">
                    <p className="font-semibold text-gray-900">박○○님</p>
                    <p className="text-sm text-gray-600">면책 절차 완료</p>
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0 w-80 bg-gray-50 p-6 rounded-xl shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <span className="ml-2 text-sm text-gray-600">5.0</span>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "상담부터 마무리까지 정말 친절하고 세심하게 도와주셨어요. 덕분에 새로운 시작을 할 수 있게 되었습니다. 우리사무소 강력 추천합니다!"
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                    <span className="text-orange-600 font-semibold">최</span>
                  </div>
                  <div className="ml-3">
                    <p className="font-semibold text-gray-900">최○○님</p>
                    <p className="text-sm text-gray-600">개인회생 성공</p>
                  </div>
                </div>
              </div>

              {/* Duplicate set for seamless loop */}
              <div className="flex-shrink-0 w-80 bg-gray-50 p-6 rounded-xl shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <span className="ml-2 text-sm text-gray-600">5.0</span>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "개인회생 절차가 복잡해서 걱정했는데, 조동식 법무사님께서 처음부터 끝까지 친절하게 설명해주시고 도와주셔서 무사히 마칠 수 있었습니다. 정말 감사합니다."
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 font-semibold">김</span>
                  </div>
                  <div className="ml-3">
                    <p className="font-semibold text-gray-900">김○○님</p>
                    <p className="text-sm text-gray-600">개인회생 성공</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Real-time Consultation Status */}
      <section className="py-16 bg-gradient-to-r from-blue-50 to-blue-100 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">실시간 상담 신청 현황</h3>
            <p className="text-xl text-gray-600">지금 이 순간에도 많은 분들이 새로운 시작을 위해 상담을 신청하고 있습니다</p>
          </div>

          <div className="relative">
            <div className="flex animate-scroll space-x-6">
              {consultationStats.concat(consultationStats).map((consultation, index) => (
                <div key={index} className="flex-shrink-0 bg-white p-6 rounded-xl shadow-sm border border-gray-200 min-w-80">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <span className="text-sm font-semibold text-green-600">상담 신청</span>
                    </div>
                    <span className="text-sm text-gray-500">{consultation.time}</span>
                  </div>
                  
                  <div className="space-y-2">
                    <div className="flex items-center space-x-2">
                      <i className="ri-user-line text-blue-600"></i>
                      <span className="font-semibold text-gray-900">{consultation.name}</span>
                      <span className="text-gray-500">•</span>
                      <span className="text-gray-600">{consultation.location}</span>
                    </div>
                    
                    <div className="flex items-center space-x-2">
                      <i className="ri-chat-3-line text-blue-600"></i>
                      <span className="text-gray-700">{consultation.type}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center mt-8">
            <div className="inline-flex items-center space-x-4 bg-white px-6 py-3 rounded-full shadow-sm">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-sm font-medium text-gray-700">실시간 업데이트</span>
              </div>
              <div className="text-gray-300">|</div>
              <div className="text-sm text-gray-600">
                오늘 <span className="font-bold text-blue-600">24건</span> 상담 신청
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">사무소 소개</h3>
            <p className="text-xl text-gray-600">신뢰와 전문성으로 고객의 새로운 시작을 함께합니다</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
                <div className="flex items-start space-x-4">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20Korean%20male%20lawyer%20in%20his%2050s%20wearing%20business%20suit%2C%20confident%20and%20trustworthy%20expression%2C%20clean%20office%20background%2C%20professional%20headshot%20for%20legal%20services%20website%2C%20conveying%2033%20years%20of%20experience%20and%20expertise&width=120&height=120&seq=lawyer-cho-dongsik&orientation=squarish"
                    alt="조동식 법무사"
                    className="w-20 h-20 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">조동식 법무사</h4>
                    <p className="text-blue-600 font-semibold mb-3">김해시법원 조정위원 | 33년 경력</p>
                    <p className="text-gray-600 leading-relaxed">
                      33년간의 풍부한 경험으로 정확하고 신속한 업무 처리를 통해 
                      고객의 법적 문제를 해결해드립니다.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
                <div className="flex items-start space-x-4">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20Korean%20male%20lawyer%20in%20his%2040s%20wearing%20business%20suit%2C%20experienced%20and%20reliable%20appearance%2C%20clean%20office%20background%2C%20professional%20headshot%20for%20legal%20services%20website%2C%20former%20court%20official%20background&width=120&height=120&seq=lawyer-cho-dongseop&orientation=squarish"
                    alt="조동섭 법무사"
                    className="w-20 h-20 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">조동섭 법무사</h4>
                    <p className="text-blue-600 font-semibold mb-3">법원 1급공무원 출신 | 집행관 경력</p>
                    <p className="text-gray-600 leading-relaxed">
                      법원 실무 경험을 바탕으로 실질적이고 효과적인 
                      최적의 해결책을 제시합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-gray-50 p-8 rounded-xl shadow-sm">
                <h4 className="text-xl font-bold text-gray-900 mb-4">사무소 철학</h4>
                <p className="text-gray-600 leading-relaxed mb-4">
                  우리법무사 조동식, 조동섭 사무소는 단순한 법률 서비스를 넘어 
                  고객의 인생에 새로운 희망을 제공하는 것을 목표로 합니다.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  정확성과 공감을 바탕으로 복잡한 법률 절차를 간소화하여 
                  고객이 안심하고 새로운 시작을 할 수 있도록 돕겠습니다.
                </p>
              </div>

              <div className="bg-blue-600 text-white p-8 rounded-xl">
                <h4 className="text-xl font-bold mb-4">800건의 성공 사례</h4>
                <p className="leading-relaxed">
                  개인회생 분야에서 축적된 풍부한 경험과 노하우로 
                  고객 만족도 100%를 달성하고 있습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xl font-bold mb-4" style={{ fontFamily: "Pacifico, serif" }}>우리법무사 조동식 조동섭 사무소</h4>
              <p className="text-gray-300 leading-relaxed">
                조동식, 조동섭 사무소는 개인회생 파산 전문 법무사로서<br />
                고객의 새로운 시작을 함께합니다.
              </p>
            </div>
            <div>
              <h5 className="font-semibold mb-4">연락처</h5>
              <div className="space-y-2 text-gray-300">
                <p>김해시 금관대로 1364번길17, 2층</p>
                <p>전화: 0507-1472-9902</p>
                <p>평일 09:00 - 18:00</p>
              </div>
            </div>
            <div>
              <h5 className="font-semibold mb-4">주요 업무</h5>
              <div className="space-y-2 text-gray-300">
                <p>개인회생 파산신청</p>
                <p>채무조정</p>
                <p>변제계획 수립</p>
                <p>면책 절차</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 우리법무사 조동식, 조동섭 사무소. All rights reserved. |
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
